/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiKeyListItem
 */
export interface ApiKeyListItem {
    /**
     * The ID of the API key (public portion, not secret).
     * @type {string}
     * @memberof ApiKeyListItem
     */
    keyId: string;
    /**
     * An optional display name for this key
     * @type {string}
     * @memberof ApiKeyListItem
     */
    name?: string | null;
    /**
     * Optional expiration time in ISO-8601 format
     * @type {Date}
     * @memberof ApiKeyListItem
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the ApiKeyListItem interface.
 */
export function instanceOfApiKeyListItem(value: object): value is ApiKeyListItem {
    if (!('keyId' in value) || value['keyId'] === undefined) return false;
    return true;
}

export function ApiKeyListItemFromJSON(json: any): ApiKeyListItem {
    return ApiKeyListItemFromJSONTyped(json, false);
}

export function ApiKeyListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'keyId': json['key_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
    };
}

export function ApiKeyListItemToJSON(json: any): ApiKeyListItem {
    return ApiKeyListItemToJSONTyped(json, false);
}

export function ApiKeyListItemToJSONTyped(value?: ApiKeyListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key_id': value['keyId'],
        'name': value['name'],
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
    };
}

